import { useQuery } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export const queryKeyIndustryAutocomplete = (query: string) => ["autocomplete-industries", query];

export const useIndustryAutocomplete = (query: string) => {
  const { apiClient } = useSalesyApiClient();

  const getAutocomplete = async () => {
    return apiClient.industries.autocomplete({ query: query ? query : undefined, standard: "SALESY" });
  };

  return useQuery({
    queryKey: queryKeyIndustryAutocomplete(query),
    queryFn: getAutocomplete,
    staleTime: 1000 * 60 * 60,
  });
};
